<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="flex-row align-center">
        <button
          type="button"
          class="ac-close-button margin-right-4"
          @click="close"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div
          class="ac-header"
        >
          Edit Rewards
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div class="ac-input-container margin-bottom-4">
        <div class="sac__font-16 semi-bold margin-bottom-4">
          Partner/Branch
        </div>
        <div class="sac__font-16 ">
          {{ customer.companyName }}
        </div>
      </div>
      <div class="sac__font-16 semi-bold margin-bottom-4">
        Customer
      </div>
      <div
        class="flex-column margin-bottom-4"
      >
        <div class="sac__font-16">
          {{ displayCustomer.lastName }}, {{ displayCustomer.firstName }}
        </div>
        <div class="sac__font-14">
          {{ displayCustomer.serviceAddress && displayCustomer.serviceAddress.length > 0 ? displayCustomer.serviceAddress[0].address1 : '' }}
        </div>
        <div class="sac__font-14">
          {{ displayCustomer.phone }}
        </div>
      </div>
      <div class="ac-input-container margin-bottom-4">
        <div class="sac__font-16 semi-bold margin-bottom-4">
          Balance
        </div>
        <div
          class="flex-row align-center"
        >
          <div class="sac__font-14 mr-2">
            {{ loyaltyName || selectedLoyaltyName }}:
          </div>
          <div class=" sac__font-14 semi-bold margin-right-4">
            {{ creditBalance }}
          </div>
          <div class="sac__font-14 mr-2">
            Voucher:
          </div>
          <div class=" sac__font-14 semi-bold">
            ${{ voucherAmount > 0 ? voucherAmount : 0 }}
          </div>
        </div>
      </div>
      <div class="ac-input-container margin-bottom-4">
        <div class="sac__font-16 semi-bold margin-bottom-4">
          Reward Type
        </div>
        <div class="flex-row">
          <button
            type="button"
            :class="[
              rewardType === 'credits' ? 'active' : '',
              'cc-transaction-btn',
            ]"
            @click="change('rewardType', 'credits')"
          >
            Credits
          </button>
          <button
            type="button"
            :class="[
              rewardType === 'voucher' ? 'active' : '',
              'cc-transaction-btn',
            ]"
            @click="change('rewardType', 'voucher')"
          >
            Voucher
          </button>
        </div>
        <div
          v-if="errorObj.rewardErr"
          class="cc-error"
        >
          {{ errorObj.rewardErr }}
        </div>
      </div>
      <div class="ac-input-container margin-bottom-4">
        <div class="sac__font-16 semi-bold margin-bottom-4">
          Transaction Type
        </div>
        <div class="flex-row">
          <button
            type="button"
            :class="[
              method === 'add' ? 'active' : '',
              'cc-transaction-btn',
            ]"
            @click="change('method', 'add')"
          >
            Add
          </button>
          <button
            type="button"
            :class="[
              method === 'subtract' ? 'active' : '',
              'cc-transaction-btn',
            ]"
            @click="change('method', 'subtract')"
          >
            Subtract
          </button>
        </div>
        <div
          v-if="errorObj.methodErr"
          class="cc-error"
        >
          {{ errorObj.methodErr }}
        </div>
      </div>
      <div
        v-if="!(rewardType === 'voucher' && method === 'subtract')"
        class="ac-input-container margin-bottom-4"
      >
        <div class="sac__font-16 semi-bold margin-bottom-4">
          Credit Amount
        </div>
        <SACInput
          field="amount"
          type="number"
          placeholder="Enter Amount"
          :value="amount"
          :change="change"
          :error="errorObj.amountErr"
        />
      </div>
      <div
        v-if="!(rewardType === 'voucher' && method === 'subtract')"
        class="ac-input-container margin-bottom-4"
      >
        <div class="sac__font-16 semi-bold margin-bottom-4">
          Reason given to homeowner
        </div>
        <SACInput
          field="reason"
          placeholder="Enter Reason"
          :value="reason"
          :change="change"
          :error="errorObj.reasonErr"
        />
      </div>
      <div
        v-if="!(rewardType === 'voucher' && method === 'subtract')"
        class="ac-input-container margin-bottom-8"
      >
        The amount and reason for the reward will be seen by the customer in the Homeowner App.
      </div>
      <div
        v-else
        class="ac-input-container margin-bottom-4"
      >
        <div
          class="sac__font-16 semi-bold margin-bottom-4"
        >
          Select Voucher
        </div>
        <div
          v-for="(voucher, idx) in memberVouchers"
          :key="idx"
          class="select-voucher-container"
        >
          <SACCheckbox
            :label="`${formatedVoucherDate(voucher)} - Awarded Filter Voucher +${voucher.amount}`"
            field="selectedVoucher"
            :checked="selectedVouchers.includes(voucher.voucherId)"
            :change="() => toggleVouchers(voucher.voucherId)"
          />
        </div>
      </div>
      <ProcessOverlay
        :show="processing"
        text="Saving Comfort Credit"
        overlayClass="ac-overlay"
      />
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-cancel-button"
        @click="close"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="newComfortCredit"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import comfortCreditsMixin from '@shared/mixins/comfortCreditsMixin';
import moment from 'moment';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SACInput from '@shared/components/sac/SACInput.vue';
import apiClient from '@shared/lib/general/apiClient';
import SACCheckbox from '../../sac/SACCheckbox.vue';

export default {
  name: 'AdjustRewards',
  components: {
    SACInput,
    ProcessOverlay,
    SACCheckbox,
  },
  mixins: [comfortCreditsMixin],
  props: {
    customer: Object,
    confirmReason: Function,
    close: Function,
  },
  data() {
    return {
      errorObj: {},
      sPartner: {},
      selectAnother: false,
      reason: '',
      amount: '',
      rewardType: '',
      method: '',
      custOptions: [],
      memberVouchers: [],
      voucherAmount: 0,
      selectedVouchers: [],
      creditBalance: 0,
    };
  },
  computed: {
    loyaltyName() {
      return this.partnerSettings.LOYALTY_PROGRAM_NAME || 'Comfort Credits';
    },
    selectedLoyaltyName() {
      return this.selectedPartnerSetting.LOYALTY_PROGRAM_NAME || 'Comfort Credits';
    },
    displayCustomer() {
      return this.customer;
    },
  },
  async mounted() {
    await this.getCustomerBalance(this.customer.id);
    await this.getInitialVoucherAmount(this.customer.id);
  },
  methods: {
    change(f, v) {
      this[f] = v;
    },
    toggleVouchers(voucherId) {
      if (this.selectedVouchers.indexOf(voucherId) >= 0) {
        this.selectedVouchers.splice(this.selectedVouchers.indexOf(voucherId), 1);
      } else {
        this.selectedVouchers.push(voucherId);
      }
    },
    formatedVoucherDate(voucher) {
      return moment(voucher.issuedDate).format('ll') || '';
    },

    async getCustomerBalance(customerId) {
      if (customerId) {
        const { data } = await apiClient({
          method: 'GET',
          url: `/comfort/credits/balance/${customerId}`,
        });
        this.creditBalance = data;
      }
    },
    async getInitialVoucherAmount(customerId) {
      if (customerId) {
        const vouchers = await this.$store.dispatch('getCustomerVouchers', customerId);
        let total = 0;
        vouchers.forEach((v) => {
          if (v.orderNumber > 0) {
            total -= v.amount;
          } else {
            total += v.amount;
          }
          this.memberVouchers = vouchers;
          this.voucherAmount = total;
        });
      }
    },
    async newComfortCredit() {
      const {
        method,
        amount,
        reason,
        rewardType,
      } = this;
      const errorObj = {};
      if (!method && !(rewardType === 'voucher' && method === 'subtract')) {
        errorObj.methodErr = 'Please select add or subtract.';
      }
      if (!rewardType) {
        errorObj.rewardErr = 'Please select a reward type.';
      }
      if ((!amount || Number(amount) === 0) && !(rewardType === 'voucher' && method === 'subtract')) {
        errorObj.amountErr = 'Please enter an amount.';
      } else if (rewardType === 'credits' && method === 'subtract' && Number(amount) > Number(this.displayCustomer.balance)) {
        errorObj.amountErr = 'The amount provided will result in a negative balance';
      }
      if (!reason && !(rewardType === 'voucher' && method === 'subtract')) {
        errorObj.reasonErr = 'Please enter a reason.';
      }
      this.errorObj = errorObj;
      if (Object.keys(errorObj).length === 0) {
        this.changeComfortCreditValue('transaction', {
          method,
          amount: rewardType === 'credits' && method === 'subtract' ? -1 * Number(amount) : Number(amount),
          reason,
          rewardType,
          corpId: this.customer.corporationId,
          customerId: this.customer.id,
        });
        if (rewardType === 'voucher' && method === 'subtract') {
          this.$store.dispatch('removeVoucher', this.selectedVouchers);
          this.close();
        } else {
        //   this.toggleActionModal(true, 'confirm-reason');
          this.confirmReason();
        }
      }
    },
  },
};
</script>

<style lang="scss">

.ac-radio-container {
  &:first-child {
    margin-right: 12px;
  }

  label {
    margin-left: 4px;
    margin-top: 3px;
  }
}
.cc-selected-member-info {
    padding: 10px;
    background-color: $NBLUE5;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
.cc-transaction-btn {
  width: 100%;
  background-color: $NBLUE5;
  padding: 10px;
  font-weight: 600;
  &.active {
    background-color: $NBLUE100;
    color: $WHITE;
  }
}
.cc-error {
  padding-left: 10px;
  padding-right: 10px;
  font-size: 14px;
  width: 100%;
  color: $TOMATO200;
  height: 48px;
}
.select-voucher-container {
  background-color: $NBLUE5;
  padding: 10px;
}
</style>
